<template>
  <el-select
    v-model="innerValue"
    filterable
    remote
    :remote-method="remoteMethod"
    :loading="loading"
    style="width: 100%"
    placeholder="Выберите пользователя"
    value-key="id"
  >
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item.name"
      :value="item"
    >
    </el-option>
  </el-select>
</template>

<script>
import { getUsers } from "@/api/users";

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      options: [],
      innerValue: undefined,
      loading: false,
    };
  },
  mounted() {
    this.options = this.value ? [this.value] : [];
    this.innerValue = this.value;
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        try {
          const response = await getUsers({ name: query });

          this.options = response?.users || [];
        } catch (error) {
          console.error("Ошибка при получении пользователей:", error);
        } finally {
          this.loading = false;
        }
      } else {
        this.options = this.value ? [this.value] : [];
      }
    },
  },
};
</script>
